export const getEnumMapping = (enums: Record<string, string | number>) => {
	return Object.values(enums)
		.filter((value) => {
			return typeof value === 'number';
		})
		.map((value) => {
			return {
				value: value as number,
				label: enums[value as number] as string,
			};
		});
};

export enum BusinessEntityType {
	'Perseroan Terbatas' = 1,
}

export enum ShareholderType {
	'Perorangan' = 1,
	BADAN_USAHA = 2,
}

export enum SegmentMarket {
	Reguler = 1,
	Captive,
}

export enum SourceOrder {
	'Captive Non JF' = 2,
	'Captive JF Commercial',
	'Captive JF Corporate',
	'Captive MTF',
}

export enum OrderType {
	'Pengajuan Fasilitas Baru' = 1,
	// 'Penambahan Fasilitas',
	// 'Perpanjangan Fasilitas',
	// 'Reaktivasi',
}

export enum OrderTypeExisting {
	'Penambahan Fasilitas' = 2,
	// 'Penambahan Fasilitas',
	'Perpanjangan Fasilitas',
	// 'Reaktivasi',
}

export enum PlafondType {
	'Non Join Financing' = 1,
	'Join Financing',
}

export enum PortfolioGuideline {
	MENARIK = 'Menarik',
	NETRAL = 'Netral',
	WASPADA = 'Waspada',
	SELECTIVE = 'Selektif',
}

export enum OfficeOwnershipStatus {
	'Milik Perusahaan' = 1,
	'Milik Owner',
	'Sewa',
}

export enum OfficeMaterialOwnership {
	'Milik Debitur' = 1,
	'Konsinyasi',
}
